import { withErrorBoundary } from 'react-error-boundary';
import type { TypeCustomScriptBlockDetailed } from 'types/autogen/contentful';
import { Humany, FindStore, CookieInformation } from './scripts';

function CustomScriptBlock(props: TypeCustomScriptBlockDetailed) {
    const {
        fields: { script }
    } = props;

    const locale = props.sys.locale;

    switch (script) {
        case 'humany':
            return <Humany locale={locale} />;
        case 'find-store':
            return <FindStore />;
        case 'cookie-information':
            return <CookieInformation locale={locale} />;
        default:
            return null;
    }
}

export default withErrorBoundary(CustomScriptBlock, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
